import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["input", "selectedPreview", "currentPreview", "placeholder", "title", "remove", "removal"];
  static values = { uploadTitle: String };

  connect() {
    if (this.previewFile && !this.objectUrl && !this.selectedPreviewTarget.hidden) this.showPreview(this.previewFile);
  }

  disconnect() {
    if (!this.element.isConnected) this.revokePreview();
  }

  preview() {
    const file = this.inputTarget.files?.[0];
    if (!file) return;

    this.showPreview(file);
  }

  showPreview(file) {
    this.revokePreview();
    this.previewFile = file;
    this.objectUrl = URL.createObjectURL(file);
    this.selectedPreviewTarget.src = this.objectUrl;
    this.selectedPreviewTarget.hidden = false;
    if (this.hasCurrentPreviewTarget) this.currentPreviewTarget.hidden = true;
    this.placeholderTarget.hidden = true;
    this.titleTarget.textContent = file.name;
    this.removeTarget.hidden = false;
    this.removalTarget.value = "0";
  }

  captureState(pendingFile) {
    return {
      files: [...this.inputTarget.files],
      previewFile: this.selectedPreviewTarget.hidden ? null : (this.previewFile || pendingFile),
      removal: this.removalTarget.value,
      currentHidden: !this.hasCurrentPreviewTarget || this.currentPreviewTarget.hidden,
      title: this.titleTarget.textContent,
    };
  }

  restoreState(state) {
    this.revokePreview();
    const transfer = new DataTransfer();
    state.files.forEach((file) => transfer.items.add(file));
    this.inputTarget.files = transfer.files;
    this.selectedPreviewTarget.removeAttribute("src");
    this.selectedPreviewTarget.hidden = true;
    if (this.hasCurrentPreviewTarget) this.currentPreviewTarget.hidden = state.currentHidden;
    this.placeholderTarget.hidden = !state.currentHidden;
    this.removeTarget.hidden = state.currentHidden;
    if (state.previewFile) this.showPreview(state.previewFile);
    this.removalTarget.value = state.removal;
    this.titleTarget.textContent = state.title;
  }

  clear() {
    this.inputTarget.value = "";
    this.revokePreview();
    this.selectedPreviewTarget.removeAttribute("src");
    this.selectedPreviewTarget.hidden = true;
    if (this.hasCurrentPreviewTarget) this.currentPreviewTarget.hidden = true;
    this.placeholderTarget.hidden = false;
    this.titleTarget.textContent = this.uploadTitleValue;
    this.removeTarget.hidden = true;
    this.removalTarget.value = "1";
    this.removalTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }

  revokePreview() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
    this.objectUrl = null;
  }
}
